import axios from "axios";
import { server } from "../api";

const IndoorPositioningEquipmentLive = {
  GetEquipment: async (machineID) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/live/equipment`,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "獲取機具即時資料失敗",
        }
      );
    }
  },
};

export default IndoorPositioningEquipmentLive;
